async function addSapyenCartToShopify() {
    const items = window.SapyenCart.getItems();
    

    const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ items })
    });

    if (!response.ok) {
        throw new Error("Failed to add items");
    }

    return response.json();
}

async function openCartDrawer() {
    const drawer = document.querySelector("cart-drawer");

    if (!drawer) return;

    const response = await fetch("/?section_id=cart-drawer");
    const html = await response.text();

    const doc = new DOMParser().parseFromString(html, "text/html");
    const newDrawer = doc.querySelector("cart-drawer");

    drawer.innerHTML = newDrawer.innerHTML;

    drawer.classList.remove("is-empty");

    if (typeof drawer.open === "function") {
        drawer.open();
    }
}

async function createStripeCheckoutSession(payload) {
  showLoader();

  try {
    const response = await fetch(
      "https://dev-api.sapyen.co/api/payments/create-checkout-session",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "super_secret_key",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      const message =
        data?.message ||
        data?.error ||
        data?.detail ||
        "Something went wrong.";

      // Show to the user
      alert(message);

      throw new Error(message);
    }

    return data;
  } catch (error) {
    alert(error.message || "Unable to create checkout session.");
    throw error;
  } finally {
    hideLoader();
  }
}


Object.assign(window.SapyenCartApi ||= {}, {
    addSapyenCartToShopify,
    openCartDrawer,
    createStripeCheckoutSession
}); 